/**
 * This transformer sets a new suggested insured sum that comes from the BE.
 */
export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (quote) => {
      if (!quote || !quote.data) {
        return;
      }

      const inputState = kasko.getState('input');

      if (inputState.suggested_insured_sum_hr === quote.data.extraData.suggested_insured_sum_hr) {
        return;
      }

      if (inputState.insured_sum_touched) {
        return;
      }

      if (kasko.getState('flags').lead_token_valid) {
        return;
      }

      kasko.dispatchEvent('set-state-input', {
        suggested_insured_sum_hr: quote.data.extraData.suggested_insured_sum_hr,
        insured_sum_hr: quote.data.extraData.suggested_insured_sum_hr,
        insured_sum_hr_human: quote.data.extraData.suggested_insured_sum_hr / 100,
      });
      kasko.dispatchEvent('set-form-input', {
        suggested_insured_sum_hr: quote.data.extraData.suggested_insured_sum_hr,
        insured_sum_hr: quote.data.extraData.suggested_insured_sum_hr,
        insured_sum_hr_human: quote.data.extraData.suggested_insured_sum_hr / 100,
      });
    },
    { slice: 'quote' },
  );
};
